module.exports = __webpack_public_path__ + "assets/img/24.c5209f60.png";